<template>
  <div class="container">
    <div class="content-container">
      <div class="guide-container">
        <div class="content-brief-container">
          <div class="content-brief-desc">
            {{ articleDetail.introduction }}
          </div>
          <div class="content-brief-title">文章导读</div>
        </div>

        <div v-if="articleDetail.videoUrl" class="video-container">
          <video
            id="videoid"
            style="
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 10px;
            "
            playsinline
            webkit-playsinline
            preload="load"
            autoplay="autoplay"
            controls="controls"
            x5-video-player-type="h5-page"
            :poster="
              articleDetail.videoUrl +
              '?x-oss-process=video/snapshot,t_1,f_jpg,w_600,h_0,m_fast'
            "
            :src="articleDetail.videoUrl"
          ></video>
        </div>
        <div
          v-if="!articleDetail.videoUrl && articleDetail.imageUrl"
          class="video-container"
        >
          <img class="article-intro-image" :src="articleDetail.imageUrl" />
        </div>
        <div class="article-label-container">
          <div v-if="articleDetail.isFine">
            <img
              style="height: 12px; margin: auto 4px; padding-bottom: 2px"
              :src="require('../.././assets/imgs/icon/article-fire.png')"
            />
            {{
              `精选${
                articleDetail.examLabel || articleDetail.extensionType
                  ? "&nbsp;&nbsp;|&nbsp;&nbsp;"
                  : ""
              }`
            }}
          </div>
          <div v-if="articleDetail.examLabel">
            {{
              `${articleDetail.examLabel.title}${
                articleDetail.extensionType ? "&nbsp;&nbsp;|&nbsp;&nbsp;" : ""
              }`
            }}
          </div>
          <div v-if="articleDetail.extensionType">
            {{ EXTENSION_TYPES[articleDetail.extensionType].name }}
          </div>
        </div>
        <div style="margin: 20px 20px 0 20px">
          <div v-if="articleDetail.titleEn" class="article-title-en">
            {{ articleDetail.titleEn.replace(/&nbsp;/g, " ") }}
          </div>
          <div v-if="articleDetail.titleCn" class="article-title-cn">
            {{ articleDetail.titleCn.replace(/&nbsp;/g, " ") }}
          </div>
          <div class="article-source">
            <span v-if="articleDetail.source"
              ># 选自{{ articleDetail.source }} </span
            ><span v-if="articleDetail.sourceCn">
              {{ articleDetail.sourceCn }}</span
            >
            <span v-if="articleDetail.sourceExam" class="article-source-exam"
              ># {{ articleDetail.sourceExam }}</span
            >
          </div>
        </div>
      </div>
      <div v-if="words.length > 0" class="vocab-container">
        <div class="content-title">重点单词</div>
        <div class="content-title-desc">
          {{ articleDetail.primaryWordsDescription }}
        </div>
        <div class="vocab-grid-container">
          <div class="vocab-item" v-for="item in words" :key="item.wordName">
            <div style="font-weight: bold">{{ item.wordName }}</div>
            <div>{{ item.explainCn }}</div>
          </div>
        </div>
        <div style="text-align: center; font-size: 9px; color: #999999">
          * 阅读完文章生词将自动加入生词本
        </div>
      </div>
      <div style="background-color: #fff">
        <div class="vocab-container">
          <div class="content-title">阅读难度对照</div>
          <div class="content-title-desc">
            选择最适合自己的阅读蓝思值可以有效提高阅读能力
          </div>
        </div>
        <img
          style="width: 100%; margin-top: -50px"
          :src="require('../../assets/imgs/article/article-level-chart.png')"
        />
      </div>
    </div>

    <more-footer-collect
      text="开始分级阅读"
      :onBack="this.onBack"
      :onButtonClick="this.startReading"
      :onClickCollect="this.onClickCollect"
      :isFavorite="articleDetail.isFavorite"
    />

    <van-popup
      v-model="vote_show"
      :close-on-click-overlay="false"
      :closeable="true"
      @close="onCloseVoteAlert"
    >
      <vote-alert
        :voteTitle="articleDetail.voteTitle"
        @onClickVote="onClickVote"
      ></vote-alert>
    </van-popup>

    <van-overlay
      :z-index="120"
      :show="showQrOverlay"
      @click="showQrOverlay = false"
    >
      <div class="wrapper">
        <div class="overlay-block">
          <img
            style="width: 100%"
            :src="require('@/assets/imgs/themeReading/qrcode_dialog.png')"
          />
          <img
            style="width: 10%; text-align: center; margin-top: 20px"
            :src="require('@/assets/imgs/themeReading/drak_close.png')"
          />
        </div>
      </div>
    </van-overlay>
    <!-- 蓝思VIP 3天 -->
    <van-overlay
      :z-index="120"
      :show="showConsumeView"
      @click="showConsumeView = false"
    >
      <div class="wrapper">
        <div class="vip-block">
          <div class="vip-img">
            <img
              style="width: 100%"
              :src="require('@/assets/imgs/my/my_vip_bg.png')"
            />
            <span class="vip-des3">会员有效期: 3天</span>
          </div>
          <span class="vip-des">3天内享受vip权限，畅读全部好文</span>
          <img
            class="vip-btn"
            :src="require('@/assets/imgs/my/vip_sure_use.png')"
            @click="onClickVipSure"
          />
        </div>
        <img
          style="width: 10%; text-align: center; margin-top: 20px"
          :src="require('@/assets/imgs/themeReading/drak_close.png')"
        />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import MoreFooter from "../../components/footer/MoreFooter";
import MoreFooterCollect from "../../components/footer/MoreFooterCollect";
import { EXTENSION_TYPES } from "../../contants/article";
import VoteAlert from "@/components/vote/VoteAlert";
import { mapState } from "vuex";
import { whetherVoted, userVote } from "@/api/vote";
import {
  getArticleDetail,
  getPrimaryWords,
  getRecommendContent,
  whetherHaveFreeMember,
  consume3Vip,
} from "@/api/article";
import * as ActionTypes from "@/store/action-types";
import CommenBuyVip from "../../components/commonBuyVip/CommenBuyVip";
import { joidCollections, removeCollections } from "../../api/collection.js";
import * as Cache from "@/lib/cache";
import { Toast } from "vant";
import { reportHomeEntry } from "@/api/report";

export default {
  data() {
    return {
      EXTENSION_TYPES: EXTENSION_TYPES,
      article: {
        desc_cn:
          "今天我们要来认识一位了不起的女性；她曾登上美元纸币，也是美国古印第安民族切诺基的第一位女性领导人，她就是Mankiller。直到2010年去世，Mankiller都一直在为美国原住民和女性权益奋斗，奥巴马总统都赞扬她为改变民族关系和鼓舞女性精神作出的贡献。让我们一起来看一看吧～",
        videoUrl:
          "https://oss-leveledreading.oss-cn-beijing.aliyuncs.com/article/28b6a4bdb59a45478bd1e55d49f3b455-20200913125246.BBB%20Grand%20Prize%20scholarship%20award%20was%20offered%20to%20Anthony%20Mmesome%20Madu%2011%20from%20Nigeria~1.mp4",
        examLabel: {
          examLabelId: 1,
          title: "课标",
          type: 1,
        },
        isFine: 1,
        extensionType: 1,
        titleEn: "These families are getting “tea-p’d” with kindness.",
        titleCn: "幸福的下午茶",
        source: "American Express",
        sourceCn: "《美国快报》",
        sourceExam: "六年级期中考试全国卷",
        primaryWordsDescription: "本文生词对应小升初考试课标重点词汇",
        isFavorite: false,
      },
      scene: 1, // 阅读前投票
      vote_show: false,
      showQrOverlay: false,
      showConsumeView: false,
    };
  },

  components: {
    // MoreFooter,
    MoreFooterCollect,
    VoteAlert,
    CommenBuyVip,
  },

  // activated() {
  //   // getArticleDetail, getPrimaryWords
  //   this.$store.dispatch(
  //     ActionTypes.GET_ARTICLE_DETAIL,
  //     this.$router.currentRoute.query.articleId
  //   );
  // },
  computed: mapState({
    words: (state) => state.article.words,
    articleDetail: (state) => state.article.articleDetail,
    contentId: (state) => state.article.contentId,
  }),
  mounted() {
    window.addEventListener("popstate", this.onBack, false);
    this.$store.dispatch(
      ActionTypes.GET_ARTICLE_DETAIL,
      this.$router.currentRoute.query.articleId
    );
    this.$store.dispatch(
      ActionTypes.GET_USER_INFO,
      this.$router.currentRoute.query.articleId
    );
    if (this.$router.currentRoute.query.entry) {
      reportHomeEntry({
        articleId: this.$router.currentRoute.query.articleId,
        entry: this.$router.currentRoute.query.entry,
      })
        .then(() => {})
        .catch(() => {});
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.onBack, false);
  },
  methods: {
    checkOther() {
      if (
        !this.$store.getters.userInfo.themeUserStatus &&
        !this.articleDetail.isFree
      ) {
        this.showQrOverlay = true;
        return;
      }
      //2、展示投票弹框
      if (
        this.articleDetail.voteTitle &&
        this.articleDetail.voteTitle.length > 0
      ) {
        this.whetherVoted();
      } else {
        this.gotoReadingPage();
      }
    },
    hasVoteTitle() {
      if (
        this.articleDetail.voteTitle &&
        this.articleDetail.voteTitle.length > 0
      ) {
        this.whetherVoted();
      } else {
        this.gotoReadingPage();
      }
    },
    //立即使用
    onClickVipSure() {
      consume3Vip()
        .then((res) => {
          this.showConsumeView = false;
          // const { data,code } = res
          this.$store.dispatch(ActionTypes.SET_USER_INFO, res.data);

          this.$toast({
            message: "3天VIP使用成功",
            duration: 1000,
          });

          // this.hasVoteTitle()
        })
        .catch((err) => {});
    },
    checkWhetherFreeMember() {
      whetherHaveFreeMember()
        .then((res) => {
          const { data } = res;
          if (data) {
            this.showConsumeView = true;
          } else {
            //没有三天 --> 支付弹框
            this.$router.push({
              path: "/payment",
            });
          }
        })
        .catch((err) => {});
    },
    //取消收藏
    onClickCancelCollect() {
      let parmas = {
        articleId: this.articleDetail.articleId,
        // scene: this.scene,
      };
      removeCollections(parmas)
        .then((res) => {})
        .catch((err) => {})
        .finally(() => {
          this.$store.dispatch(
            ActionTypes.GET_ARTICLE_DETAIL,
            this.$router.currentRoute.query.articleId
          );
        });
    },
    //点击收藏
    onClickCollect() {
      //加入
      let parmas = {
        articleId: this.articleDetail.articleId,
      };
      if (this.articleDetail.isFavorite) {
        //取消
        this.onClickCancelCollect();
        return;
      }
      joidCollections(parmas)
        .then((res) => {})
        .catch((err) => {
          console.log("-----err--" + JSON.stringify(err));
        })
        .finally(() => {
          this.$store.dispatch(
            ActionTypes.GET_ARTICLE_DETAIL,
            this.$router.currentRoute.query.articleId
          );
        });
    },
    onBack() {
      if(this.$router.currentRoute.query.entry){
        this.$router.replace({ path: "/home" });
      }else{
        this.$router.back({ path: "/home" });
      }
      // window.location.href = "/home"
    },
    startReading() {
      //1、是否收藏
      if (this.articleDetail.isFavorite) {
        this.hasVoteTitle();
        // if (
        //   this.articleDetail.voteTitle &&
        //   this.articleDetail.voteTitle.length > 0
        // ) {
        //   this.whetherVoted();
        // } else {
        //   this.gotoReadingPage();
        // }
        return;
      }

      //未收藏 判断当前文章是否付费
      if (this.articleDetail.isFree) {
        this.hasVoteTitle();
        return;
      }
      //未收藏 付费文章-->判断 用户会员有效期
      //用户vip无效⬇
      if (!this.$store.getters.userInfo.vipStatus) {
        //是否为 阅读主题营文章
        if (this.articleDetail.isActivity) {
          //是主题营
          if (
            !this.$store.getters.userInfo.themeUserStatus &&
            !this.articleDetail.isFree
          ) {
            this.showQrOverlay = true;
            return;
          }
          //anna二维码
        } else {
          //非 主题营
          // 是否弹窗3天会员活动
          this.checkWhetherFreeMember();
          //支付弹窗
          // this.$router.push({
          //   path: "/payment",
          // });
          return;
        }
      }

      //2、展示投票弹框
      this.hasVoteTitle();
      // if (
      //   this.articleDetail.voteTitle &&
      //   this.articleDetail.voteTitle.length > 0
      // ) {
      //   this.whetherVoted();
      // } else {
      //   this.gotoReadingPage();
      // }
    },
    gotoReadingPage() {
      if (this.contentId) {
        this.$router.push({ path: "/readingPage" });
      } else {
        this.$toast({
          message: "未查找到文章内容",
          duration: 1000,
        });
      }
    },
    // 投票===start====
    whetherVoted() {
      let parmas = {
        articleId: this.articleDetail.articleId,
        scene: this.scene,
      };
      whetherVoted(parmas)
        .then((res) => {
          if (!res.data) {
            this.vote_show = true;
          } else {
            this.gotoReadingPage();
          }
        })
        .catch((err) => {
          this.gotoReadingPage();
        });
    },
    onCloseVoteAlert() {
      this.vote_show = false;
      this.gotoReadingPage();
    },
    onClickVote(viewpoint) {
      let parmas = {
        articleId: this.articleDetail.articleId,
        scene: this.scene,
        viewpoint: viewpoint,
      };
      userVote(parmas)
        .then((res) => {
          this.vote_show = false;
          this.gotoReadingPage();
        })
        .catch((err) => {
          this.gotoReadingPage();
        });
    },
    // 投票===end====
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container {
  min-height: 100vh;
  padding-bottom: 50px;
  background: #F7F8FB;
}

.guide-container {
  padding: 15px;
  background: #ffffff;
}

.content-container {
  flex: 1;
  overflow: scroll;
}

.content-brief-container {
  display: flex;
}

.content-brief-desc {
  flex: 1;
  font-size: 12px;
  line-height: 21px;
  margin-right: 16px;
  margin-top: 50px;
  font-family: serif, SimSun, STSong;
}

.content-brief-title {
  text-align: center;
  width: 14px;
  font-size: 20px;
  line-height: 24px;
  font-family: Pangmeng;
}

.video-container {
  margin-top: 20px;
  background-color: #ffffff;
}

.article-label-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  font-size: 11px;
  color: #999999;
}

.article-title-en {
  font-size: 14px;
  margin: 0 0 10px 0;
}

.article-title-cn {
  font-size: 14px;
  font-weight: bold;
  margin: 0 0 10px 0;
  font-family: serif, SimSun, STSong;
}

.article-source {
  font-size: 11px;
  color: #999999;
  font-family: serif, SimSun, STSong;

  &-exam {
    color: #333333;
  }
}

.vocab-container {
  margin-top: 15px;
  background: #ffffff;
  padding: 20px 15px;
}

.vocab-grid-container {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.vocab-item {
  margin: 4px 1%;
  padding: 6px 0;
  width: 31%;
  justify-content: center;
  text-align: center;
  background-color: #f4f9fe;
  border-radius: 10px;
  font-weight: 12px;
  font-family: serif, SimSun, STSong;
  color: #013666;
}

.article-intro-image {
  position: relative;
  width: 100%;
  border-radius: 10px;
}

.content-title {
  font-size: 18px;
  font-weight: bold;
  font-family: serif, SimSun, STSong;
}

.content-title-desc {
  color: #666666;
  font-size: 11px;
  margin: 10px 0;
}

.aler-wrapper {
  background-color: #fff;
  width: calc(100vw - 20px);
  box-sizing: border-box;
  padding: 10px 20px 20px;
  border-radius: 10px;
}

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.overlay-block {
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  // height: 120px;
}

.vip-block {
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #fff;
  border-radius: 12px;
  padding: 20px 9px 20px 9px;
}

.vip-img {
  /* background: url('../../assets/imgs/my/my_vip_bg.png') no-repeat; */
  /* background-size: cover; */
  position: relative;
}

.vip-des {
  font-size: 14px;
  font-weight: 800;
  color: #333333;
  line-height: 20px;
  margin-top: 15px;
  font-family: serif, SimSun, STSong;
}

.vip-des3 {
  position: absolute;
  left: 34px;
  bottom: 21px;
  color: #DED0B4;
  font-size: 11px;
  line-height: 15px;
  font-weight: 800;
  font-family: serif, SimSun, STSong;
}

.vip-btn {
  width: 155px;
  height: 32px;
  margin-top: 15px;
}

.vip-block {
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #fff;
  border-radius: 12px;
  padding: 20px 9px 20px 9px;
}

.vip-img {
  /* background: url('../../assets/imgs/my/my_vip_bg.png') no-repeat; */
  /* background-size: cover; */
  position: relative;
}

.vip-des {
  font-size: 14px;
  font-weight: 800;
  color: #333333;
  line-height: 20px;
  margin-top: 15px;
  font-family: serif, SimSun, STSong;
}

.vip-des3 {
  position: absolute;
  left: 34px;
  bottom: 21px;
  color: #DED0B4;
  font-size: 11px;
  line-height: 15px;
  font-weight: 800;
  font-family: serif, SimSun, STSong;
}

.vip-btn {
  width: 155px;
  height: 32px;
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// app/pages/article/ArticleGuidePage.vue